import { SubscriberPackageDelimiter } from 'library/ts/model/user/SubscriberPackageDelimiter';
import { SubscriberPackageKey } from 'library/ts/model/user/SubscriberPackageKey';
import { SubscriberPackageValue } from 'library/ts/model/user/SubscriberPackageValue';
import { UserType } from 'library/ts/model/user/UserType';
export const UserTypeLibrary = {
    [UserType.ANON]: [
        `${SubscriberPackageKey.ANON}${SubscriberPackageDelimiter.EMPTY}${SubscriberPackageValue.EMPTY}`,
        `${SubscriberPackageKey.SB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_0}`,
        `${SubscriberPackageKey.TSB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_0}`
    ],
    [UserType.LC]: [
        `${SubscriberPackageKey.SB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_6}`,
        `${SubscriberPackageKey.TSB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_6}`,
        `${SubscriberPackageKey.TVE}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_6}`
    ],
    [UserType.CF]: [
        `${SubscriberPackageKey.SB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_14}`,
        `${SubscriberPackageKey.TSB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_14}`
    ],
    [UserType.LCP]: [
        `${SubscriberPackageKey.SB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_22}`,
        `${SubscriberPackageKey.TSB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_22}`,
        `${SubscriberPackageKey.TVE}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_22}`,
        `${SubscriberPackageKey.SB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_23}`,
        `${SubscriberPackageKey.TSB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_23}`,
        `${SubscriberPackageKey.TVE}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_23}`
    ],
    [UserType.MVPD_AUTHZ]: [
        `${SubscriberPackageKey.SB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_14}`,
        `${SubscriberPackageKey.TSB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_14}`,
        `${SubscriberPackageKey.TVE}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_14}`,
        `${SubscriberPackageKey.SB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_15}`,
        `${SubscriberPackageKey.TSB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_15}`,
        `${SubscriberPackageKey.TVE}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_15}`,
        `${SubscriberPackageKey.SB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_17}`,
        `${SubscriberPackageKey.TSB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_17}`,
        `${SubscriberPackageKey.TVE}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_17}`,
        `${SubscriberPackageKey.SB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_24}`,
        `${SubscriberPackageKey.TSB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_24}`,
        `${SubscriberPackageKey.TVE}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_24}`,
        `${SubscriberPackageKey.SB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_25}`,
        `${SubscriberPackageKey.TSB}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_25}`,
        `${SubscriberPackageKey.TVE}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_25}`
    ],
    [UserType.MVPD_AUTHZ_TVE]: [
        `${SubscriberPackageKey.TVE}${SubscriberPackageDelimiter.V_PIPE}${SubscriberPackageValue.VALUE_18}`
    ]
};
